import { ContentHeaderButton } from '../contentHeaderButton'
import { useNavigate } from 'react-router-dom'

const back_icon = require('../../../assets/images/icons/back_icon.png')

// Кнопка, возврата на предыдущую страницу 
export default function NavigateBackButton() {
    const navigate = useNavigate()
    return (
        <div className='content-header-back-button-div'>
            <ContentHeaderButton imageSrc={back_icon} onClick={() => navigate(-1)}/>
        </div>
    )
}
